var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWithlessLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 24,
    viewBox: "0 0 81 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4764 15.8269H31.8325L33.3099 10.9096L34.7873 15.8269H36.1435L38.6462 8.04297H36.9373L35.4489 12.9272L33.9935 8.04297H32.6374L31.182 12.9162L29.6936 8.04297H27.9736L30.4764 15.8269Z",
    fill: "#07132B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2773 9.58398V15.8273H41.0083V9.58398H39.2773Z",
    fill: "#07132B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1096 8.04297H41.6719V9.55345H44.1085V15.8269H45.8395V9.55345H48.2761V8.04297H45.8383V9.55318H44.1096V8.04297Z",
    fill: "#07132B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9404 15.8269H50.6714V12.5744H53.7585V15.8269H55.5005V8.04297H53.7585V11.075H50.6714V8.04297H48.9404V15.8269Z",
    fill: "#07132B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6826 14.3058H58.4133V15.8269H61.8646V14.3054H58.4136V8.04297H56.6826V14.3058Z",
    fill: "#07132B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1514 15.8269H62.5615L64.2912 15.8269V14.3292H62.5615V8.04297H68.0963V9.5314H64.2925V11.1301H67.7655V12.5744H64.2925V14.3274H68.1514V15.8269Z",
    fill: "#07132B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1749 15.9484C73.0492 15.9484 74.1628 15.0553 74.1628 13.5669C74.1628 10.7334 70.5133 11.4059 70.5133 10.0498C70.5133 9.61979 70.8772 9.38825 71.4946 9.38825C72.09 9.38825 72.553 9.61979 73.0161 10.1049L74.1407 8.99134C73.5564 8.34084 72.6192 7.92188 71.5277 7.92188C69.918 7.92188 68.7934 8.78186 68.7934 10.2152C68.7934 12.9495 72.4428 12.2549 72.4428 13.7212C72.4428 14.1843 72.0128 14.471 71.2851 14.471C70.4692 14.471 69.8849 14.1512 69.3888 13.5669L68.2642 14.6804C69.0249 15.5404 69.8959 15.9484 71.1749 15.9484Z",
    fill: "#07132B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0977 15.9484C78.972 15.9484 80.0856 15.0553 80.0856 13.5669C80.0856 10.7334 76.4362 11.4059 76.4362 10.0498C76.4362 9.61979 76.8 9.38825 77.4175 9.38825C78.0128 9.38825 78.4759 9.61979 78.939 10.1049L80.0636 8.99134C79.4792 8.34084 78.542 7.92188 77.4505 7.92188C75.8408 7.92188 74.7162 8.78186 74.7162 10.2152C74.7162 12.9495 78.3656 12.2549 78.3656 13.7212C78.3656 14.1843 77.9356 14.471 77.208 14.471C76.3921 14.471 75.8077 14.1512 75.3116 13.5669L74.187 14.6804C74.9478 15.5404 75.8188 15.9484 77.0977 15.9484Z",
    fill: "#07132B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 5.94043,
    width: 12,
    height: 4.8,
    fill: "#07132B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 13.1621,
    width: 12,
    height: 4.8,
    fill: "#07132B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 12,
    height: 4.8,
    transform: "rotate(-90 6 12)",
    fill: "#07132B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2002,
    y: 24,
    width: 12,
    height: 4.8,
    transform: "rotate(-90 13.2002 24)",
    fill: "#07132B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithlessLogo);
export default __webpack_public_path__ + "static/media/withless-logo.0a0d6bbc6924323762c175354a39cf5f.svg";
export { ForwardRef as ReactComponent };